export default {
	//判断用户是否有查看小程序用户敏感信息的权限
	hasSensitiveAuth: function() {
		var hasAuth = false;
		try {
			//判断用是否超级管理员
			let isSuper = false;
			let userinfo = JSON.parse(localStorage.getItem("userInfo"));
			if (userinfo != undefined && userinfo != null && Object.keys(userinfo).length > 0) {
				if (userinfo.isSuper == 1) {
					isSuper = true;
				}
			}
			if (isSuper) {
				hasAuth = true;
			} else {
				//获取当前用户菜单按钮权限
				let btnPermissionList = [];
				let btnPermissionData = localStorage.getItem("btnPermissionList");
				if (btnPermissionData != undefined && btnPermissionData != null || btnPermissionData
					.length > 0) {
					btnPermissionList = JSON.parse(btnPermissionData);
				}
				var code = "YHLBSensitive";
				hasAuth = btnPermissionList.includes(code);
			}
		} catch (e) {

		}
		return hasAuth;
	},
}